import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import Lib from '../../../commons/lib';
import NaploLista from './NaploLista';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../BufeTooltips';

class NTAKBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: undefined,
      isNaploTabActive: false,
    };
  }

  componentDidMount() {
    if (this.props.globals.hasRole(['BUFE_NTAK_RMS_NAPLO'])) {
      this.toggle('1');
    }
  }

  toggle(tab) {
    this.setState({
      isNaploTabActive: tab === '1',
    });
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              NTAK
              
              {/* <YouTube data={videoData} /> */}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {this.props.globals.hasRole(['BUFE_NTAK_RMS_NAPLO']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Napló
                        <CustomTooltip text={getTooltip('ntaknaplo')} id="ntaknaploTT" />
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {this.props.globals.hasRole(['BUFE_NTAK_RMS_NAPLO']) && (
                    <TabPane tabId="1">
                      <NaploLista
                        {...this.props}
                        globals={this.props.globals}
                        active={this.state.isNaploTabActive}
                        ref={(instance) => { this.child1 = instance; }}
                      />
                    </TabPane>
                  )}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NTAKBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default NTAKBase;
